export enum CustomerVisibility {
  Visible = 'VISIBLE',
  InternalOnly = 'INTERNAL_ONLY',
}
